import { useParams, Link, Navigate } from 'react-router-dom';
import { motion } from 'framer-motion';
import { ArrowLeft } from 'lucide-react';
import { SEO } from '../components/SEO';
import { blogPosts } from '../data/blogPosts';

const BlogPost = () => {
  const { slug } = useParams();
  const post = blogPosts.find((p) => p.slug === slug);

  if (!post) return <Navigate to="/blog" replace />;

  const articleJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Article',
    headline: post.title,
    datePublished: post.date,
    articleSection: post.tag,
    description: post.excerpt,
  };

  return (
    <div className="bg-navy" data-testid="blog-post-page">
      <SEO title={post.title} description={post.excerpt} path={`/blog/${post.slug}`} jsonLd={articleJsonLd} />
      <section className="bg-navy text-white pt-40 pb-20 px-6 sm:px-10 lg:px-16">
        <div className="max-w-3xl mx-auto">
          <Link to="/blog" data-testid="blog-post-back-link" className="inline-flex items-center gap-2 text-white/60 hover:text-cyan text-sm mb-8 transition-colors">
            <ArrowLeft size={14} /> Back to Privacy Blog
          </Link>
          <p className="font-mono text-xs uppercase tracking-[0.2em] text-cyan mb-6">{post.tag} · {post.date} · {post.readTime}</p>
          <motion.h1
            initial={{ opacity: 0, y: 16 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6 }}
            className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-tight"
          >
            {post.title}
          </motion.h1>
        </div>
      </section>
      <article className="py-16 sm:py-24 px-6 sm:px-10 lg:px-16 border-t border-white/5">
        <div className="max-w-2xl mx-auto space-y-6" data-testid="blog-post-body">
          {post.body.split('\n\n').map((para, i) => (
            <p key={i} className="text-white/75 text-base sm:text-lg leading-relaxed">{para}</p>
          ))}
        </div>
      </article>
    </div>
  );
};

export default BlogPost;
